import type { CartItem } from "../types";

/** Срок жизни черновика неоплаченного заказа (ссылка ЮKassa и восстановление корзины). */
export const PENDING_ORDER_DRAFT_TTL_MS = 48 * 60 * 60 * 1000;

export interface PendingOrderDraft {
  orderId?: string;
  /** Номер заказа 1С — для отображения клиенту */
  idZakaz?: string;
  paymentUrl?: string;
  createdAt: string;
  expiresAt?: string;
  items: CartItem[];
  checkoutForm?: {
    fullName?: string;
    address?: string;
    phone?: string;
    comment?: string;
  };
}

export type SavePendingDraftInput = Omit<
  PendingOrderDraft,
  "createdAt" | "expiresAt"
> & { expiresAt?: string };

export function getPendingDraftExpiryTime(draft: PendingOrderDraft): number {
  if (draft.expiresAt) {
    return new Date(draft.expiresAt).getTime();
  }
  return new Date(draft.createdAt).getTime() + PENDING_ORDER_DRAFT_TTL_MS;
}

export function isPendingDraftExpired(draft: PendingOrderDraft): boolean {
  return Date.now() > getPendingDraftExpiryTime(draft);
}
